/**
 * The screen's three action paints as class lists, spelled once (see `AccountScreen.module.css`):
 * every one is `shared/ui/pillButton`'s shape at the screen's size, under `emberButton`'s quiet pill
 * (the one primary) or `ghostButton`'s ink and danger outlines.
 */

import ember from '~/shared/ui/emberButton.module.css';
import ghost from '~/shared/ui/ghostButton.module.css';
import pill from '~/shared/ui/pillButton.module.css';

import screen from './AccountScreen.module.css';

const PILL = `${String(pill.pill)} ${String(screen.pill)}`;

export const PRIMARY_PILL = `${String(ember.ember)} ${String(ember.pill)} ${String(ember.quiet)} ${PILL}`;
export const SECONDARY_PILL = `${String(ghost.ghost)} ${String(ghost.ink)} ${PILL}`;
export const DANGER_PILL = `${String(ghost.ghost)} ${String(ghost.danger)} ${PILL}`;
